import { persistor } from "@/redux/store";
import { Dispatch } from "@reduxjs/toolkit";
import { clearUser } from "@/redux/slices/userSlice";
import { clearBasicInfo } from "@/redux/slices/basicInfoSlice";
import { clearAccountType } from "@/redux/slices/accountTypeSlice";
import { clearContactInfo } from "@/redux/slices/contactInfoSlice";
import { clearPersonalInfo } from "@/redux/slices/personalInfoSlice";
import { clearAllChecks } from "@/redux/slices/checkerSlice";
import { resetBusinessType } from "@/redux/slices/businessTypeSlice";
import { resetCACVerification } from "@/redux/slices/cacVerificationSlice";
import { resetCompanyDetails } from "@/redux/slices/companyDetailsSlice";
import { resetRepresentativeDetails } from "@/redux/slices/representativeDetailsSlice";
import Cookies from 'js-cookie';
/**
 * Clears all user data, Redux state, and localStorage
 */
export const clearAllUserData = (dispatch: Dispatch): void => {
  // Clear localStorage items
  Cookies.remove("qwid-token");
  Cookies.remove("deviceId");
  Cookies.remove("persist:root");

  // Clear Redux slices
  dispatch(clearBasicInfo());
  dispatch(clearUser());
  dispatch(clearAllChecks());
  dispatch(clearAccountType());
  dispatch(clearContactInfo());
  dispatch(clearPersonalInfo());
  dispatch(resetBusinessType());
  dispatch(resetCACVerification());
  dispatch(resetCompanyDetails());
  dispatch(resetRepresentativeDetails());

  // Purge persisted state
  persistor.purge();


};

